import gql from 'graphql-tag';

export const DELETE_CLOSE_REASON = gql`
  mutation DeleteBPFCloseReason($input: DeleteCloseReasonInput!) {
    bpf {
      result: deleteCloseReason(input: $input) {
        error
        success
        entity {
          id
          type
          label
          flowId
          isActive
          createdDateTime
          modifiedDateTime
        }
      }
    }
  }
`;
